
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getRequestOtpDtoFormGroup() {
return new FormGroup({
    phoneId: new FormControl<string | undefined>(''),
    mailId: new FormControl<string | undefined>(''),
    mobileNumber: new FormControl<string | undefined>(''),
})
;
}
      